import React from 'react';

const PrivacyPolicy = () => {
  const lastUpdated = "February 19, 2026";

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.title}>Privacy Policy</h1>
        <p style={styles.subtitle}>HighEnd Holidays Homes</p>
        <p style={styles.lastUpdated}>Last Updated: {lastUpdated}</p>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. Introduction</h2>
          <p style={styles.body}>
            Welcome to HighEnd Holidays Homes. We are committed to protecting your personal data 
            and your privacy. This policy explains how we collect and use your information when 
            you use our application and services in the UAE.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Information We Collect</h2>
          <p style={styles.body}>We collect the following types of information:</p>
          <ul style={styles.list}>
            <li style={styles.bullet}><span style={styles.bold}>Identity Data:</span> Name, Email, and Phone Number for account creation.</li>
            <li style={styles.bullet}><span style={styles.bold}>Booking Data:</span> Dates of stay and property preferences for holiday rentals.</li>
            <li style={styles.bullet}><span style={styles.bold}>Reward Data:</span> Information on your reading progress and earned "Network Credits" to manage your loyalty balance.</li>
            <li style={styles.bullet}><span style={styles.bold}>Device Identifiers:</span> We collect unique device IDs to prevent fraud within our reward system and ensure account security.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. Payment Processing</h2>
          <p style={styles.body}>
            All payments for holiday home rentals are processed securely via <span style={styles.bold}>Stripe</span>. 
            We do not store your full credit card details on our servers. Stripe's use of your 
            personal information is governed by their own Privacy Policy.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. How We Use Your Data</h2>
          <p style={styles.body}>
            Your data is used to process bookings, provide notifications regarding your 
            stay, and manage the "Read-to-Earn" reward system. We do not sell your personal 
            data to third parties.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Data Retention & Deletion</h2>
          <p style={styles.body}>
            We retain your data as long as your account is active. Under UAE Law, you have the 
            right to request the deletion of your account and all associated personal data at 
            any time via the settings or by contacting us.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Contact Us</h2>
          <p style={styles.body}>
            HighEnd Holidays Homes<br />
            Al Quoz, Dubai, United Arab Emirates<br />
            Email: info@backlinksai.in
          </p>
        </section>

        <button 
          style={styles.button} 
          onClick={() => window.history.back()}
        >
          I Understand
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: { 
    minHeight: '100vh', 
    backgroundColor: '#fff', 
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' 
  },
  content: { 
    maxWidth: '800px', 
    margin: '0 auto', 
    padding: '40px 20px' 
  },
  title: { 
    fontSize: '32px', 
    fontWeight: '900', 
    color: '#1a1a1a', 
    marginBottom: '5px' 
  },
  subtitle: { 
    fontSize: '20px', 
    color: '#4f46e5', 
    fontWeight: '700', 
    marginBottom: '10px' 
  },
  lastUpdated: { 
    fontSize: '14px', 
    color: '#666', 
    marginBottom: '30px' 
  },
  section: { 
    marginBottom: '30px' 
  },
  heading: { 
    fontSize: '20px', 
    fontWeight: '800', 
    color: '#1a1a1a', 
    marginBottom: '10px' 
  },
  body: { 
    fontSize: '16px', 
    color: '#444', 
    lineHeight: '1.6' 
  },
  list: {
    paddingLeft: '20px',
    marginTop: '10px'
  },
  bullet: { 
    fontSize: '16px', 
    color: '#444', 
    lineHeight: '1.6', 
    marginBottom: '10px' 
  },
  bold: { 
    fontWeight: '700', 
    color: '#000' 
  },
  button: { 
    backgroundColor: '#4f46e5', 
    color: '#fff', 
    border: 'none',
    padding: '16px 32px', 
    borderRadius: '12px', 
    fontWeight: '800', 
    fontSize: '16px', 
    cursor: 'pointer',
    marginTop: '20px',
    transition: 'background-color 0.2s'
  }
};

export default PrivacyPolicy;